import { GuestApiPayload } from './guestMapper';

export interface MergeGuestsOptions {
  removedGuestIds?: string[];
}

export const mergeGuestPayloads = (
  serverGuests: GuestApiPayload[],
  localGuests: GuestApiPayload[],
  options: MergeGuestsOptions = {},
): GuestApiPayload[] => {
  const merged = new Map(serverGuests.map((guest) => [guest.id, guest]));

  if (options.removedGuestIds?.length) {
    for (const guestId of options.removedGuestIds) {
      merged.delete(guestId);
    }
  }

  for (const localGuest of localGuests) {
    const existing = merged.get(localGuest.id);
    merged.set(localGuest.id, existing ? { ...existing, ...localGuest } : localGuest);
  }

  return Array.from(merged.values());
};

export const shouldAllowGuestRemoval = (
  serverCount: number,
  mergedCount: number,
  removedGuestIds?: string[],
): boolean => {
  if (removedGuestIds?.length) {
    return true;
  }

  return mergedCount < serverCount;
};
